(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeButtons', PropriedadeButtons);

  PropriedadeButtons.$inject = [
    '$routeParams',
    '$route'
  ];

  // eslint-disable-next-line max-lines-per-function
  function PropriedadeButtons($routeParams, $route) {
    return {
      restrict: 'E',
      scope: {
        active: '<',
        onActivate: '&',
        gleba: '<',
        weatherForecast: '<',
        showWeatherButton: '<'
      },
      templateUrl: 'views/propriedade/propriedade-buttons.html',
      // eslint-disable-next-line max-lines-per-function
      link(scope, element) {
        element.addClass('btn-group-map');

        scope.activate = function(key) {
          $route.updateParams({
            data: null
          });
          scope.onActivate({ name: key });
        };

        scope.canReadRecommendations = function() {
          if (scope.$root.permissions) {
            return scope.$root.permissions.recomendacao.canRead ||
                   scope.$root.permissions.correcaoSolo.canRead;
          }
          return false;
        };

        scope.canReadApplications = function() {
          if (scope.$root.permissions) {
            return scope.$root.permissions.pulverizacao.canRead ||
                   scope.$root.permissions.recomendacaoSemeadura.canRead ||
                   scope.$root.permissions.correcaoSolo.canRead ||
                   scope.$root.permissions.plantio.canRead;
          }
          return false;
        };

        scope.isActivityActive = function() {
          return ($routeParams.date || $routeParams.historyDate) && $routeParams.activeGleba;
        };
      }
    };
  }
}());
